"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradMeterHelp = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var copy_1 = require("../../copy");
var MeterHelp_styled_1 = require("./MeterHelp.styled");
var MeterHelpExamples_1 = require("./MeterHelpExamples");
var TradMeterHelp = function () {
    var _a = (0, core_1.useComponents)(), Heading4 = _a.Heading4, Disclosure = _a.Disclosure;
    var _b = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _b.Copy, copy = _b.copy;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MeterHelp_styled_1.StyledHelp, null,
            react_1.default.createElement("section", null,
                react_1.default.createElement(Heading4, { as: "h2" },
                    react_1.default.createElement(Copy, { copyKey: "tradMeterHelpStandardNumericalMeterHeading" })),
                react_1.default.createElement(MeterHelp_styled_1.StyledHelpLayout, null,
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(MeterHelp_styled_1.StyledNumericalMeter, null)),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Copy, { copyKey: "tradMeterHelpStandardNumericalMeterInfo" })))),
            react_1.default.createElement("section", null,
                react_1.default.createElement(Heading4, { as: "h2" },
                    react_1.default.createElement(Copy, { copyKey: "tradMeterHelpDialMeterHeading" })),
                react_1.default.createElement(MeterHelp_styled_1.StyledHelpLayout, null,
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(MeterHelp_styled_1.StyledDialMeter, null)),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Copy, { copyKey: "tradMeterHelpDialMeterInfo" }))))),
        react_1.default.createElement(Disclosure, { title: copy('tradMeterHelpExamples') },
            react_1.default.createElement(MeterHelpExamples_1.MeterHelpExamples, null))));
};
exports.TradMeterHelp = TradMeterHelp;
